import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=85e4d27c&"
import script from "./FormDialog.vue?vue&type=script&lang=ts&"
export * from "./FormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports